import { useEffect, useState } from "react";
import general from "../../../general";
import { useReactive, useScroll } from "ahooks";
import moment from "moment";
import { Link } from "react-router-dom";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import '../../../css/gameTrade.css';
import GfyxItem from "../../components/GfyxItem";
import SearchAlert from "../../trade/SearchAlert";

export default props => {
  const data = useReactive({
    active: props.active,
  });
  useEffect(() => {
    data.active = props.active;
  }, [props]);
  const [trades, setTrades] = useState([]);
  const [more, setMore] = useState();
  const [filter, setFilter] = useState({
    index: 0,
    text: '全部交易',
    sort_type: '',
    game_device_type: '0',
  })
  const [filterVisible, setFilterVisible] = useState(false)

  useEffect(() => {
    if (props.active) {
      load(filter)
    }
  }, [props.active, filter.index, filter.sort_type, filter.game_device_type]);

  useEffect(() => {
    props.setOperate((
      <div style={{display:'flex',alignItems:'center'}} onClick={() => setFilterVisible(true)}>
        <div style={{paddingRight:'5px'}}>{filter.text}</div>
        <img src="resources/250410/down.png" alt="" width={8}/>
      </div>
    ))
  }, [filter.text, props.setOperate]);

  const handleConfirm = (action) => {
    setFilter({
      index: action.index,
      text: action.text,
      sort_type: action.sort_type,
      game_device_type: action.game_device_type ?? '0',
    });
  };
 
  const load = (parms = {}) => {
    if (data.loading) {
      return;
    }
    data.loading = true;
    Dialog.loading();
    general.axios.post('/gameRelatedTradeList', {
      trade_type: '3',
      sort_type: parms.sort_type ?? filter.sort_type,
      game_device_type: parms.game_device_type ?? filter.game_device_type,
      game_id: props.query.id,
      pagination: { count: 100, page: 1 }
    })
      .finally(() => {
        data.loading = false;
        Dialog.close();
      })
      .then(res => {
        if (!data.init){
          setTimeout(() => {
            window.scrollTo({top: 0,});
          }, 100);
        }
        data.init = true;
        let result = res.data.data;
        setTrades(result.list);
        setMore(result.paginated.more);
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  }

  return (
    <>
    <SearchAlert
      visible={filterVisible}
      onClose={() => setFilterVisible(false)}
      value={filter}
      onConfirm={handleConfirm}
    />
    <div className="game-trade" style={{paddingTop:'10px'}}>
      {/* <img className='top-icon' src="/resources/game/trade-banner.png" alt="" /> */}

      {trades.map(trade =>
        <div key={trade.trade_id}>
          <GfyxItem>{trade}</GfyxItem>
        </div>
        )}
      {trades.length == 0 && data.init ? <div className="recovery-empty"><img src="/resources/game/detail-trade-place.png" alt="" />暂无交易</div> : null}
      {trades.length > 6 && data.init && more == 0 ? <div className="view-end">别撩啦！已经到底啦~</div> : null}
    </div>
    </>
  );
};